import { createApp } from "vue";
// import Vue from 'vue'
import store from "./store/index";
import App from "./App.vue";
import router from "./router";

import "aos/dist/aos.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// (App).use(router).mount('#app')

// const baseUrl = `http://localhost:8000`;
// const baseUrl = `http://172.104.193.133/admin`;
const baseUrl = `http://latamup.com/admin`;
const baseUrlApi = `${baseUrl}/index.php/api`;
const baseUrlStorage = `${baseUrl}/storage/`;
const baseUrlImages = `${baseUrl}/images/`;

const app = createApp(App);

app.use(store);
app.use(router);
app.use(baseUrl);
app.use(baseUrlApi);
app.use(baseUrlStorage);
app.use(baseUrlImages);
app.mount("#app");

app.provide("baseUrlStorage", baseUrlStorage);
